import { filter, values } from 'lodash'
import { IGrupoPreguntas, IListaPreguntas, IModelPregunta } from '../../model/candidato-api'

export class Preguntas {
  grupos: GrupoPreg[]

  noseleccionables: IModelPregunta[]

  constructor(lista: IListaPreguntas) {
    this.grupos = values(lista.grupos).map((g) => new GrupoPreg(g))
    this.noseleccionables = lista.noSelectable
  }
}

export class GrupoPreg {
  list: IModelPregunta[]

  constructor(g: IGrupoPreguntas) {
    this.list = this.filter(g.list)
  }

  private filter(l: IModelPregunta[]) {
    // solo las principales
    return filter(l, (l) => !l.subpreg)
  }
}
